import { api } from './axios';

export interface AppSettingDto {
  key: string;
  value: string;
  description: string | null;
  group: string;
  sensitive: boolean;
  hasValue: boolean;
}

export const settingsApi = {
  list: () => api.get<AppSettingDto[]>('/superadmin/settings').then((r) => r.data),
  listByGroup: (group: string) =>
    api.get<AppSettingDto[]>(`/superadmin/settings/group/${group}`).then((r) => r.data),
  update: (values: Record<string, string>) =>
    api.put<void>('/superadmin/settings', { values }),
  testEmail: (to: string) => api.post<void>('/superadmin/settings/email/test', { to }),
};

export const passwordApi = {
  forgot: (email: string) => api.post<void>('/auth/forgot-password', { email }),
  reset: (token: string, newPassword: string) =>
    api.post<void>('/auth/reset-password', { token, newPassword }),
  changePassword: (oldPassword: string, newPassword: string) =>
    api.post<void>('/auth/change-password', { oldPassword, newPassword }),
};
